var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "combo-container" },
    [
      _c(
        "div",
        [_c("addApplicant", { on: { addApplicant: _vm.addComboUser } })],
        1
      ),
      _c(
        "div",
        [
          _c("b-table", {
            attrs: {
              fields: _vm.fields,
              items: _vm.newApplicantList,
              hover: "",
              "foot-clone": "",
              bordered: "",
              striped: ""
            },
            scopedSlots: _vm._u([
              {
                key: "moduleSessionList",
                fn: function(row) {
                  return [
                    _c(
                      "b-form-group",
                      [
                        _c(
                          "b-form-checkbox-group",
                          { attrs: { stacked: "" } },
                          _vm._l(_vm.msList, function(option) {
                            return _c(
                              "b-form-checkbox",
                              {
                                key: option.value,
                                attrs: {
                                  value: option.value,
                                  disabled: row.item.bookingDone,
                                  name: "flavour3a"
                                },
                                model: {
                                  value:
                                    _vm.newApplicantList[row.index].selected,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.newApplicantList[row.index],
                                      "selected",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "newApplicantList[row.index].selected"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(option.value) +
                                    "\n                        "
                                )
                              ]
                            )
                          })
                        )
                      ],
                      1
                    )
                  ]
                }
              },
              {
                key: "action",
                fn: function(row) {
                  return [
                    _c(
                      "b-button",
                      {
                        attrs: {
                          variant: "outline-info",
                          size: "sm",
                          disabled: row.item.bookingDone
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            _vm.popUpBookingModal(
                              row.item,
                              row.index,
                              $event.target
                            )
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                    Preview Booking\n                "
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("p", [_vm._v(_vm._s(_vm.mark))]),
      _c(
        "b-modal",
        {
          ref: "bookModal",
          attrs: {
            id: "bookModal",
            "hide-footer": "",
            size: "lg",
            title: _vm.applicant.fullname + " " + _vm.applicant.nricFin
          },
          on: { hide: _vm.hideBookModal },
          model: {
            value: _vm.showBookModal,
            callback: function($$v) {
              _vm.showBookModal = $$v
            },
            expression: "showBookModal"
          }
        },
        [
          !!_vm.applicant.fullname
            ? _c(
                "div",
                [
                  _c("b-alert", { attrs: { show: "", variant: "dark" } }, [
                    _vm._v("Module Selected")
                  ]),
                  _vm._l(_vm.applicant.selected, function(item, index) {
                    return _c("p", [
                      _vm._v(
                        "\n               - " + _vm._s(item) + "\n            "
                      )
                    ])
                  }),
                  _c("b-alert", { attrs: { show: "", variant: "dark" } }, [
                    _vm._v("Suggested")
                  ]),
                  _vm._l(_vm.applicant.suggested, function(item, index) {
                    return _c("p", [
                      _vm._v(
                        "\n                " +
                          _vm._s(item.moduleName) +
                          ":\n                "
                      ),
                      item.hasOwnProperty("sessionTime")
                        ? _c(
                            "span",
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm
                                      .$moment(item.sessionTime, "X")
                                      .format("DD-MM-YYYY HH:mm")
                                  ) +
                                  " - " +
                                  _vm._s(item.language) +
                                  " \n                    "
                              ),
                              _c(
                                "b-button",
                                {
                                  on: {
                                    click: function($event) {
                                      _vm.changeSuggestedData(item)
                                    }
                                  }
                                },
                                [_vm._v("change")]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  })
                ],
                2
              )
            : _c("div", [_c("p", [_vm._v("Applicant False")])]),
          _c(
            "div",
            [
              _c(
                "b-button",
                {
                  attrs: { block: "", variant: "outline-info" },
                  on: { click: _vm.bookSelectedModuleSession }
                },
                [_vm._v("\n                Book Modules\n            ")]
              ),
              _c(
                "b-button",
                {
                  attrs: { block: "", variant: "danger" },
                  on: { click: _vm.hideBookModal }
                },
                [_vm._v("Cancel")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "b-modal",
        {
          ref: "changeDate",
          attrs: { title: "change date", id: "changeDate", scrollable: true },
          on: { hide: _vm.hideChangeMsModal },
          model: {
            value: _vm.showChangeMsModal,
            callback: function($$v) {
              _vm.showChangeMsModal = $$v
            },
            expression: "showChangeMsModal"
          }
        },
        [
          !!_vm.changeMsList
            ? _c(
                "div",
                _vm._l(_vm.changeMsList, function(item, index) {
                  return _c(
                    "p",
                    { key: "msList" + index },
                    [
                      item != _vm.newMs
                        ? _c(
                            "b-button",
                            {
                              key: "msListChange" + index,
                              attrs: {
                                block: "",
                                variant: "outline-secondary"
                              },
                              on: {
                                click: function($event) {
                                  _vm.selectOtherMs(item)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(item.moduleName) +
                                  ": " +
                                  _vm._s(
                                    _vm
                                      .$moment(item.sessionTime, "X")
                                      .format("DD-MM-YYYY HH:mm")
                                  ) +
                                  " - " +
                                  _vm._s(item.language) +
                                  "\n                "
                              )
                            ]
                          )
                        : _c(
                            "b-button",
                            {
                              key: "msListChange" + index,
                              attrs: { block: "", variant: "secondary" },
                              on: {
                                click: function($event) {
                                  _vm.selectOtherMs(item)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(item.moduleName) +
                                  ": " +
                                  _vm._s(
                                    _vm
                                      .$moment(item.sessionTime, "X")
                                      .format("DD-MM-YYYY HH:mm")
                                  ) +
                                  " - " +
                                  _vm._s(item.language) +
                                  "\n\n                "
                              )
                            ]
                          )
                    ],
                    1
                  )
                })
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d44f5f1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d44f5f1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/comboBook/index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0d44f5f1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/comboBook/index.vue
// module chunks = 13